import { BusinessModuleRef } from '../models/serializable/business-module-ref.js';

export abstract class ICopyWithBusinessRef {
  /**
   * Creates a deep copy of the object and replaces the business ref field.
   */
  abstract copyWithBusinessRef(businessRef: BusinessModuleRef): this;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static isInstance(arg: any): arg is ICopyWithBusinessRef {
    return arg && arg.copyWithBusinessRef && typeof(arg.copyWithBusinessRef) == 'function';
  }
}
